module.exports = __webpack_public_path__ + "img/asian-noodles-1.b5c271e3.jpg";